import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ErrorMessage } from '@interfaces/error-message';
import { SubPcgEntry } from '@models/sub-pcg-entry';

export type SubPcgEntryFormType = {
  id: FormControl<number | undefined>;
  accountNumber: FormControl<string | null>;
  label: FormControl<string | undefined>;
};

export class SubPcgEntryForm extends FormGroup<SubPcgEntryFormType> {
  get accountNumber(): FormControl<string | null> {
    return this.controls.accountNumber;
  }
  get accountNumberErrorMessage(): ErrorMessage {
    return this.accountNumber.touched && this.accountNumber.hasError('required')
      ? {
          error: 'Champ vide',
          message: `Le numéro de compte est requis`
        }
      : null;
  }
  get id(): FormControl<number | undefined> {
    return this.controls.id;
  }
  get label(): FormControl<string | undefined> {
    return this.controls.label;
  }

  constructor(accountNumberRequired?: boolean) {
    super({
      id: new FormControl<number | undefined>(undefined),
      accountNumber: new FormControl(null, accountNumberRequired ? [Validators.required] : null),
      label: new FormControl<string | undefined>(undefined)
    });
  }

  fromSubPcgEntry(subPcgEntry: SubPcgEntry): void {
    this.patchValue(subPcgEntry);
  }

  toSubPcgEntry(): SubPcgEntry {
    return this.getRawValue() as SubPcgEntry;
  }
}
